export default {
  "content": "<path d=\"M13 4H6v16h1v2H5a1 1 0 01-1-1V3a1 1 0 011-1h8v2zM11 22H9v-2h2v2zM15 22h-2v-2h2v2zM20 21a1 1 0 01-1 1h-2v-2h1v-6.5h2V21z\" fill=\"#7B61FF\"/><path d=\"M21.207 6.293a1 1 0 010 1.414l-4.5 4.5-1.414-1.414L18.086 8H9V6h9.086l-2.793-2.793 1.414-1.414 4.5 4.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};